var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid p-0 m-0 body"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.htmlBody)}})])}
var staticRenderFns = []

export { render, staticRenderFns }